import { useParams } from "react-router-dom";
import { LoadingParams } from "../../app/types";

const useSessionId = () => {
  const params = useParams<LoadingParams>();
  if (params.sessionId === undefined) {
    return undefined;
  }
  return parseInt(params.sessionId, 10);
};

export default useSessionId;
